// extracted by mini-css-extract-plugin
export var paginationContainer = "_4i-0";